
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class GoodsItem extends Vue {
  @Prop({ default: () => {} }) data: any;
  @Prop({ default: false }) isBatch: boolean;

  get storeProduct() {
    const { sellUnit, sellUnitWay } = this.data;
    
    // 如果没有销售单位规格，直接返回单位名称
    if (!sellUnit) {
      return sellUnitWay || ''
    }
    
    // 如果是千克单位且数量小于1，转换为克显示
    const isKilogram = sellUnitWay?.toLowerCase() === 'kg'
    if (sellUnit < 1 && isKilogram) {
      return `${Math.round(sellUnit * 1000)}g`
    }
    
    // 数量为1时只显示单位，否则显示数量+单位
    return sellUnit === 1 ? sellUnitWay : `${sellUnit}${sellUnitWay}`
  }
  handleEdit() {
    this.$emit("edit", this.data);
  }
  handleGoodsDetail() {
    this.$router.push({
      path: "/addGoods",
      query: {
        type: "edit",
        goodsId: this.data.goodsId,
      },
    });
  }
}
